import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalBody, ModalHeader } from 'reactstrap';
import { IModalProps } from '../../../types';
import { FilterUserActionsTableForm } from '../../UserActions/FilterUserActionsTableForm';

export const FilterUserActions: FunctionComponent<IModalProps> = (props) => {
  const { hideModal } = props;
  const { t } = useTranslation();

  return (
    <>
      <ModalHeader className="font-montserrat m-0 border-0">
        {t('common.filter')}
      </ModalHeader>
      <ModalBody>
        <FilterUserActionsTableForm onCancel={hideModal} />
      </ModalBody>
    </>
  );
};
